"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Colors = _interopRequireDefault(require("../../styles/Colors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: _Colors.default.textElementGrey
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.301194 0.800598C0.691718 0.410074 1.32488 0.410074 1.71541 0.800598L6.00011 5.08574L10.2887 0.796677C10.6792 0.406153 11.3124 0.406153 11.7029 0.796677C12.0934 1.1872 12.0934 1.82037 11.7029 2.21089L6.70722 7.20706C6.3167 7.59758 5.68353 7.59758 5.29301 7.20706L0.301194 2.21481C-0.0893303 1.82429 -0.0893303 1.19112 0.301194 0.800598Z"
  }));
};
var _default = ChevronDownIcon;
exports.default = _default;